/**
 * Created by staffanrantzow on 22/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { connect } from 'react-redux';
import { changeStartDate, changeEndDate } from 'redux/modules/datepicker-range';
import { initialState } from 'redux/modules/datepicker-range/reducer';
require('react-datepicker/dist/react-datepicker.css');
import { replace } from 'react-router-redux';
import moment from 'moment';

export class DatepickerRange extends React.Component {

  static propTypes = {
    changeStartDate: PropTypes.func.isRequired,
    changeEndDate: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    dateFilter: PropTypes.object.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.object.isRequired
    }).isRequired
  };

  constructor (props) {
    super(props);

    this.updateEndDate = this.updateEndDate.bind(this);
    this.updateStartDate = this.updateStartDate.bind(this);
  }

  componentWillMount = () => {
    const { startDate, endDate } = this.props.location.query;
    this.props.changeStartDate(startDate || initialState.dateFilter.startDate);
    this.props.changeEndDate(endDate || initialState.dateFilter.endDate);
  }

  updateStartDate (startDate) {
    this.replaceQuery(startDate.format('YYYY-MM-DD'), this.props.dateFilter.endDate);
    this.props.changeStartDate(startDate);
    this.removeFocus();
  }

  updateEndDate (endDate) {
    this.replaceQuery(this.props.dateFilter.startDate, endDate.format('YYYY-MM-DD'));
    this.props.changeEndDate(endDate);
    this.removeFocus();
  }

  replaceQuery (startDate, endDate) {
    this.props.replace({
      pathname: this.props.location.pathname,
      query: Object.assign({}, this.props.location.query, {
        startDate, endDate
      })
    });
  }

  removeFocus () {
    setTimeout(() => { document.activeElement.blur(); }, 0);
  }

  render () {
    const showErrorClass = !this.props.dateFilter.error ? 'datepicker-error' : 'error show';

    return (
      <div className='datepicker-range'>
        <DatePicker
          selected={moment(this.props.dateFilter.startDate)}
          onChange={this.updateStartDate}
          placeholderText={proxyCounterpart('FROM')}
          className='date-picker'
          dateFormat='YYYY-MM-DD'
          fixedHeight
          popperPlacement='bottom-start'
        />
        <DatePicker
          selected={moment(this.props.dateFilter.endDate)}
          onChange={this.updateEndDate}
          placeholderText={proxyCounterpart('TO')}
          className='date-picker'
          dateFormat='YYYY-MM-DD'
          fixedHeight
          popperPlacement='bottom-start'
        />
        <p className={showErrorClass}><Translate content='DATE_COMPARE_ERROR' /></p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dateFilter: state.filters.dateFilter,
    location: state.router.locationBeforeTransitions
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeStartDate: (date) => dispatch(changeStartDate(date)),
    changeEndDate: (date) => dispatch(changeEndDate(date)),
    replace: (url) => dispatch(replace(url))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DatepickerRange);



/** WEBPACK FOOTER **
 ** ./src/components/datepicker-range/datepicker-range.js
 **/